import { Env } from "classes"

export const reason_cancel_body = (reason: string, sg: any, email: string) => {
  const reasons: { [key: string]: any } = {
    CLIENT_REQUEST: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "CLIENT_REQUEST",
        description: "Cancelar SG por solicitud del cliente",
        executer: {
          name: email, //id de front
          id: "Omnix Store", //OMNIX
        },
        channelId: "", //enviar vacio
        customerOrderId: sg?.salesChannelId, //ID de EOC
        requestId: "", //enviar vacio
        returnMethod: "", //enviar vacio
        returnType: "", //enviar vacio
        status: "canceled", //enviar canceled
        employeeId: "", //enviar vacio
        storeId: "", //enviar vacio
      },
    },
    PICKING_ERROR: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "PICKING_ERROR",
        description: "Cancelar SG por series no disponibles para pickear",
        executer: {
          name: email, //id de front
          id: "Omnix Store", //OMNIX
        },
      },
    },
    SERIES_NOT_AVAILABLE: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "SERIES_NOT_AVAILABLE",
        description: "Cancelar SG por series no disponibles",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
      },
    },
    DATA_ERROR: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "DATA_ERROR",
        description: "Cancelar SG por error de datos en la orden",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
      },
    },
    LACK_OF_STOCK: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "LACK_OF_STOCK",
        description: "Cancelar SG por falta de stock",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
      },
    },
    SINISTER_ORDER: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "SINISTER_ORDER",
        description: "Cancelar SG por siniestro",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
      },
    },
    MAX_DELIVERY_ATTEMPT: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "MAX_DELIVERY_ATTEMPT",
        description: "Cancelar SG por maximo intento de entrega",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
      },
    },
    NOT_DELIVERY_PAYMENT: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "NOT_DELIVERY_PAYMENT",
        description: "Cancelar SG por no pago contra entrega",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
      },
    },
    BIOMETRIC_FAILED: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "BIOMETRIC_FAILED",
        description: "Cancelar SG por validación biometrica fallida",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
      },
    },
    NOT_PICKED_UP: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "NOT_PICKED_UP",
        description: "Cancelar SG por No Retiro",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
        channelId: "",
        customerOrderId: sg?.salesChannelId,
        requestId: "",
        returnMethod: "",
        returnType: "",
        status: "canceled",
        employeeId: "",
        storeId: "",
      },
    },
    UNKNOW_REASON: {
      entityId: sg?.salesChannelId,
      action: "CANCEL",
      custom: {
        reason: "UNKNOW_REASON",
        description: "Motivo desconocido",
        executer: {
          name: email, //id de front
          id: "Omnix Store",
        },
      },
    },
  }
  return reasons?.hasOwnProperty(reason) ? reasons[reason] : {}
}

const CLIENT_REQUEST = "Cancelación por solicitud del cliente"
const PICKING_ERROR = "Series no disponibles"
const SERIES_NOT_AVAILABLE = "Series no disponible"
const DATA_ERROR = "Error de datos"
const LACK_OF_STOCK = "Cancelar por falta de stock"
const SINISTER_ORDER = "Cancelar orden por Siniestro"
const MAX_DELIVERY_ATTEMPT = "Cancelar por máximos intentos de entrega"
const NOT_DELIVERY_PAYMENT = "Cancelar por no pago contra entrega"
const BIOMETRIC_FAILED = "Cancelación por validación biométrica fallida"
// const UNKNOW_REASON = "Motivo desconocido"
const NOT_PICKED_UP = "Cancelar por no retiro"

const _REASON_DESCRIPTIONS_DELIVERED_SOURCE: Record<string, string> = {
  CUSTOMER_REJECTS: "Cancelar SG Cliente rechaza",
  DANGEROUS_AREA: "Cancelar SG Zona peligrosa",
  NO_COVERAGE: "Cancelar SG No cobertura",
  UNCONTACTED_MEETING_POINT: "Cancelar SG Punto de encuentro no contactado",
  EXPIRED_DNI: "Cancelar SG DNI caduco",
  PILOT_DOES_NOT_COMPLY: "Cancelar SG No cumple piloto",
  ABDCP_DEMANDABLE_DEBT: "Cancelar SG ABDCP deuda exigible",
  ABDCP_REJECTION: "Cancelar SG ABDCP rechazo",
  ABDCP_SERVICE_SUSPENDED: "Cancelar SG ABDCP servicio suspendido",
  CHANNEL_REQUEST: "Cancelar SG Solicitud canal",
  POSSIBLE_FRAUD: "Cancelar SG Posible fraude",
  WORN_FOOTPRINTS: "Cancelar SG Huellas desgastadas",
  NOT_VALID_SIEBEL: "Cancelar SG No válido Siebel",
  CU_REJECTION: "Cancelar SG Rechazo CU",
  TDE_REJECTION: "Cancelar SG Rechazo TDE",
  INVALID_PIN: "Cancelar SG PIN porta no válido",
  CUSTOMER_REJECTION_PIN: "Cancelar SG PIN porta cliente rechaza",
  BIOMETRIC_FAILED_CUSTOMER: "Cancelar SG Biometría fallida de cliente",
  BIOMETRIC_FAILED_COURIER: "Cancelar SG Biometría fallida de courier",
  PORTABILITY_PIN_NOT_SUCCESSFUL: "Cancelar SG Pin de portabilidad no exitoso",
}

export const reason_cancel_delivered_source_body = (reason: string, sg: any, email: string) => {
  //eslint-disable-next-line
  const description_reason = _REASON_DESCRIPTIONS_DELIVERED_SOURCE[reason] || eval(reason) || reason
  console.log("description_reason", description_reason)
  return {
    entityId: sg?.salesChannelId,
    action: "DELIVERED_IN_SOURCE",
    custom: {
      description: "Pedido retornado en tienda",
      sourceId: sg?.source?.id,
      location: {
        latitude: "",
        longitude: "",
      },
      executer: {
        name: email, //id de front
        id: "Omnix Store",
      },
    },
    customCancel: {
      reason,
      description: description_reason,
    },
  }
}

const get_cancel_reasons = (current_status: string, shippingtype: string) => {
  const statusses = Env.theme.entel.sg[shippingtype.toUpperCase()].status

  const cancel_reasons_hd: any = {
    [statusses[0]]: [
      { label: DATA_ERROR, value: "DATA_ERROR" },
      { label: CLIENT_REQUEST, value: "CLIENT_REQUEST" },
      { label: LACK_OF_STOCK, value: "LACK_OF_STOCK" },
    ],
    [statusses[1]]: [
      { label: DATA_ERROR, value: "DATA_ERROR" },
      { label: PICKING_ERROR, value: "PICKING_ERROR" },
      { label: CLIENT_REQUEST, value: "CLIENT_REQUEST" },
      { label: LACK_OF_STOCK, value: "LACK_OF_STOCK" },
    ],
    [statusses[2]]: [
      { label: CLIENT_REQUEST, value: "CLIENT_REQUEST" },
      { label: DATA_ERROR, value: "DATA_ERROR" },
      { label: PICKING_ERROR, value: "PICKING_ERROR" },
    ],
    [statusses[3]]: [{ label: SERIES_NOT_AVAILABLE, value: "SERIES_NOT_AVAILABLE" }],
    // -- Same State With Typo From Backend
    [statusses[8]]: [{ label: SINISTER_ORDER, value: "SINISTER_ORDER" }],
    [statusses[20]]: [{ label: SINISTER_ORDER, value: "SINISTER_ORDER" }],
    // --
    [statusses[9]]: [
      { label: SINISTER_ORDER, value: "SINISTER_ORDER" },
      { label: MAX_DELIVERY_ATTEMPT, value: "MAX_DELIVERY_ATTEMPT" },
      { label: NOT_DELIVERY_PAYMENT, value: "NOT_DELIVERY_PAYMENT" },
      { label: BIOMETRIC_FAILED, value: "BIOMETRIC_FAILED" },
      ...Object.entries(_REASON_DESCRIPTIONS_DELIVERED_SOURCE).map(([value, label]) => ({
        label,
        value,
      })),
    ],
    [statusses[18]]: [{ label: MAX_DELIVERY_ATTEMPT, value: "MAX_DELIVERY_ATTEMPT" }],
    default: [],
  }

  const cancel_reasons_sp: any = {
    ...cancel_reasons_hd,
    [statusses[8]]: [{ label: NOT_PICKED_UP, value: "NOT_PICKED_UP" }],
    default: [],
  }

  let cancel_reasons = shippingtype.toUpperCase() === "SP" ? cancel_reasons_sp : cancel_reasons_hd
  return cancel_reasons[current_status.toUpperCase()] || cancel_reasons.default
}

export default get_cancel_reasons
